<template>
	<CHeader fixed with-subheader light style="max-height: 56px;">
	<CToggler
		in-header
		class="mfe-3 d-lg-none"
		v-c-emit-root-event:toggle-sidebar-mobile
	>
		<FaIcon icon="bars" class="font-2xl d-inline-block" />
		<span class="mfs-2 position-relative font-sm" style="top:-6px;">منو</span>
	</CToggler>
	<CToggler
		in-header
		class="mfe-3 d-md-down-none"
		v-c-emit-root-event:toggle-sidebar
	/>

	<!-- <img class="c-header-brand m-auto d-lg-none"
		src="//statics.affili.ir/storage/assets/logo/affili.png"
		style="min-height:initial;width:70px;height:auto"
		:alt="$t('affili')"
	/> -->
	<CHeaderNav class="mfs-auto">
		<!-- <TheLocale /> -->
		<!-- <TheHeaderDropdownAccnt/> -->
		<General />
    </CHeaderNav>
	<!-- <PageHintRouter /> -->

	<!-- <CSubheader class="px-3">
		<CBreadcrumbRouter class="border-0"/>
		<PageHintRouter />
    </CSubheader> -->
  </CHeader>
</template>

<script>
// import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
// import PageHintRouter from './PageHintRouter'
// import TheLocale from './TheLocale'
import General from './General'

export default {
	name: 'TheHeader',
	components: {
		// TheHeaderDropdownAccnt,
		// PageHintRouter,
		// TheLocale,
		General,
	},
}
</script>

<style lang="scss" scoped>
    // ol.breadcrumb {
    //     overflow-x: scroll;
    //     overflow-y: hidden;
    //     white-space: nowrap;
    //     display: block;
    //     margin-bottom: 0;

    //     li {
    //         flex: 0 0 auto;
    //         display: inline;
    //     }
    // }
</style>
